module.exports = __webpack_public_path__ + "img/downtown.b10c60a9.jpg";